import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { Info } from "lucide-react";

const InfoToolTip = ({ info = "" }: { info: string }) => {
  return (
    <HoverCard openDelay={200}>
      {/*
        1.4.13 Content on Hover or Focus — AA / 2.1.1 Keyboard — A. The trigger used to be
        the bare <Info> svg, which has no tabIndex and so could never be focused — the card
        opened for pointer users only. A real button makes it focusable (Radix opens the
        card on focus), and aria-label carries the help text so assistive tech receives it
        even if the card never opens.
      */}
      <HoverCardTrigger asChild>
        <button
          type="button"
          aria-label={`More information: ${info}`}
          className="rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <Info
            aria-hidden="true"
            className="text-[11px] text-white"
            size={16}
            fill="gray"
          />
        </button>
      </HoverCardTrigger>
      <HoverCardContent align="start">
        <p className="max-w-64 text-xs text-muted-foreground">{info}</p>
      </HoverCardContent>
    </HoverCard>
  );
};

export default InfoToolTip;
